Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = getActiveElement;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getActiveElement() {
  return typeof document !== 'undefined' && document.activeElement;
}